.container {
    margin-top: 24px;
}

.fieldContainer {
    margin-top: 12px;
}

.effectivenessAndNotice {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.summitGuideSection {
    margin-top: 24px;
}

.filesHeader {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.filesList {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.circleRow {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
}

.aiReviewComments {
    margin-top: 10px;
}